import React, { FC } from 'react';
import { ClockIcon } from 'shared/pages/projectEdit/components/LMS/LessonsEditor/styles';

export const ClockButton: FC<{ onClick: () => void }> = ({ onClick }) => (
  <ClockIcon onClick={onClick}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5Z" fill="#909090" />
      <path d="M8.5 4H7.5V8.5H11.5V7.5H8.5V4Z" fill="#909090" />
    </svg>
  </ClockIcon>
);
import React, { FC } from 'react';
import { ClockIcon } from 'shared/pages/projectEdit/components/LMS/LessonsEditor/styles';

export const ClockButton: FC<{ onClick: () => void }> = ({ onClick }) => (
  <ClockIcon onClick={onClick}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5Z" fill="#909090" />
      <path d="M8.5 4H7.5V8.5H11.5V7.5H8.5V4Z" fill="#909090" />
    </svg>
  </ClockIcon>
);
